<template>
    <div ref="jobviewMap" class="af-jobview-map" :style="{width: '100%', height: this.height}"/>
</template>

<script>
    import {mapState} from 'vuex';
    import {loadMapScripts} from '@/utils/helpers';

    export default {
        name: 'JobViewMap',

        props: {
            zoom: Number,
            height: {
                type: String,
                default: () => '280px',
            },
        },

        data() {
            return {
                map: null,
                marker: null,
            };
        },

        computed: {
            ...mapState({
                $_job: state => state.job.job,
            }),
        },

        methods: {
            initialiseMap() {
                const job = this.$_job;

                if (!job || !job.latitude || !job.longitude) {
                    return;
                }

                const gMap = this.getGMapInstance();

                const latLng = {
                    lat: parseFloat(job.latitude),
                    lng: parseFloat(job.longitude),
                };

                this.map = new gMap.Map(this.$refs.jobviewMap, {
                    center: latLng,
                    zoom: this.zoom || 14,
                });

                this.marker = new gMap.Marker({
                    map: this.map,
                    position: latLng,
                    title: job.job_title,
                });
            },

            getGMapInstance() {
                // eslint-disable-next-line no-undef
                return google.maps;
            },
        },

        mounted() {
            const job = this.$_job;

            if (job && job.latitude && job.longitude) {
                loadMapScripts(this.initialiseMap);
            }
        },

        beforeDestroy() {
            if (this.marker) {
                this.marker.setMap(null);
            }
        },
    };
</script>
